import { useLocation } from "react-router-dom";
import {
  MobileNavigationBar,
  MobileNavItem,
} from "./styledComponents/NavigationBarComponents";
import {
  LJAlogo,
  LeaderboardIcon,
  SettingsIcon,
  ShoppingCartIcon,
  ProfileIcon,
} from "../../constants/icons/navbarIcons";
import { COLORS } from "../../constants/colors/colors";
import { GlassmorphismContainer } from "../GlassmorphismContainer/GlassmorphismContainer";
import { useAppSelector } from "../../store/hooks";
import { CONTRAST_ENUM } from "../../pages/SettingsPage/constants/constants";

const getIconColor = (
  locationPath: string,
  path: string,
  contrast: CONTRAST_ENUM,
): string => {
  if (locationPath === path) return COLORS.AQUA;
  if (contrast === CONTRAST_ENUM.WHITE) return COLORS.BOUNDLESS_BLUE;
  return COLORS.WHITE;
};

const Navigation = () => {
  const location = useLocation();

  const contrast = useAppSelector((state) => state.userInfo.contrast);

  const navItems = [
    {
      path: "/shop",
      icon: (
        <ShoppingCartIcon
          fill={getIconColor(location.pathname, "/shop", contrast)}
          width="1.875rem"
          height="1.875rem"
        />
      ),
    },
    {
      path: "/profile",
      icon: (
        <ProfileIcon
          fill={getIconColor(location.pathname, "/profile", contrast)}
          width="1.875rem"
          height="1.875rem"
        />
      ),
    },
    {
      path: "/home",
      icon: (
        <LJAlogo
          width="1.8rem"
          height="1.875rem"
          primaryColor={
            location.pathname === "/home" || contrast === CONTRAST_ENUM.WHITE
              ? "#385F73"
              : "#FFF"
          }
          secondaryColor={
            location.pathname === "/home" || contrast === CONTRAST_ENUM.WHITE
              ? "#489EAD"
              : "#FFF"
          }
        />
      ),
    },
    {
      path: "/leaderboard",
      icon: (
        <LeaderboardIcon
          fill={getIconColor(location.pathname, "/leaderboard", contrast)}
          width="1.875rem"
          height="1.875rem"
        />
      ),
    },
    {
      path: "/settings",
      icon: (
        <SettingsIcon
          fill={getIconColor(location.pathname, "/settings", contrast)}
          width="1.875rem"
          height="1.875rem"
        />
      ),
    },
  ];

  return (
    <MobileNavigationBar>
      <GlassmorphismContainer
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        hasBorder
        borderRadius="32rem"
        padding="0.5rem"
        contrast={contrast}
      >
        {navItems.map((item) => (
          <MobileNavItem
            key={item.path}
            to={item.path}
            isActive={location.pathname === item.path}
          >
            {item.icon}
          </MobileNavItem>
        ))}
      </GlassmorphismContainer>
    </MobileNavigationBar>
  );
};

export default Navigation;
